import React from "react";
import { Buildings, IdentificationBadge, Pulse, UserCircle } from "@phosphor-icons/react";

export const DISPLAY_ITEMS = [
  {
    label: "Client",
    value: "client",
    sortField: "client.name",
    icon: <UserCircle weight="duotone" />,
    caption: "(Default)",
  },
  {
    label: "Insurance Company",
    value: "insurance-company",
    sortField: "i.name",
    icon: <Buildings weight="duotone" />,
  },
  {
    label: "Clinician",
    value: "clinician",
    sortField: "pri_user.first_name",
    icon: <IdentificationBadge weight="duotone" />,
  },
  {
    label: "Supervisor",
    value: "supervisor",
    sortField: "sec_user.first_name",
    icon: <IdentificationBadge weight="duotone" />,
  },
  {
    label: "Status",
    value: "status",
    sortField: "client_status",
    icon: <Pulse weight="duotone" />,
  },
];

export const FILTER_ITEMS = ({
  clientsCountList,
  clientFilter,
  setClientFilter,
  insuranceCountList,
  insuranceCompanyFilter,
  setInsuranceCompanyFilter,
  clinicianCountList,
  clinicianFilter,
  setCliniciansFilter,
  supervisorCountList,
  supervisorFilter,
  setSupervisorFilter,
  statusCountList,
  statusFilter,
  setStatusFilter,
}) => [
  {
    label: "Client",
    value: "client",
    // countLabel: "client",
    icon: <UserCircle weight="duotone" />,
    countObject: clientsCountList || [],
    state: clientFilter,
    setState: setClientFilter,
  },
  {
    label: "Insurance Company",
    value: "insurance-company",
    countLabel: "client",
    icon: <Buildings weight="duotone" />,
    countObject: insuranceCountList || [],
    state: insuranceCompanyFilter,
    setState: setInsuranceCompanyFilter,
  },
  {
    label: "Clinician",
    value: "clinician",
    countLabel: "client",
    icon: <IdentificationBadge weight="duotone" />,
    countObject: clinicianCountList || [],
    state: clinicianFilter,
    setState: setCliniciansFilter,
  },
  {
    label: "Supervisor",
    value: "supervisor",
    countLabel: "client",
    icon: <IdentificationBadge weight="duotone" />,
    countObject: supervisorCountList || [],
    state: supervisorFilter,
    setState: setSupervisorFilter,
  },
  {
    label: "Status",
    value: "status",
    countLabel: "client",
    icon: <Pulse weight="duotone" />,
    countObject: statusCountList || [],
    state: statusFilter,
    setState: setStatusFilter,
  },
];
